module.exports = __webpack_public_path__ + "static/img/bgimg3-5.362cacb2.png";